/**
 * Error action types
 */
export const STORE_ERRORS = 'STORE_ERRORS';
export const DELETE_ERRORS = 'DELETE_ERRORS';
export const STORE_FILES_ERROR = 'STORE_FILES_ERROR';
